var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useQueryClient } from "react-query";
import { useIntl } from "react-intl";
import OnixCodetableItemsForm from "./OnixCodetableItemsForm";
import { navigation } from "../../components/navigation";
import { fetchOnixCodetableItemById, updateOnixCodetableItem, ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY, } from "../../api/onixService";
var OnixCodetableItemsEdit = function () {
    var id = useParams().id;
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var formatMessage = useIntl().formatMessage;
    var kyRef = useRef(ky);
    useEffect(function () {
        kyRef.current = ky;
    }, [ky]);
    var _a = useState(null), initialValues = _a[0], setInitialValues = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var returnPath = React.useMemo(function () {
        var _a, _b;
        var params = new URLSearchParams(location.search);
        var onixCodetableId = params.get("onixCodetableId");
        return onixCodetableId
            ? "".concat((_a = navigation.onixCodetableItems) === null || _a === void 0 ? void 0 : _a.path, "?onixCodetableId=").concat(onixCodetableId)
            : (_b = navigation.onixCodetableItems) === null || _b === void 0 ? void 0 : _b.path;
    }, [location.search]);
    useEffect(function () {
        var alive = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var item, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, fetchOnixCodetableItemById(kyRef.current, id)];
                    case 1:
                        item = _d.sent();
                        if (!alive)
                            return [2 /*return*/];
                        setInitialValues(__assign(__assign({}, item), { codetableId: (_c = (_b = item === null || item === void 0 ? void 0 : item.onixCodetable) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.onixCodetableId, onixCodetable: item === null || item === void 0 ? void 0 : item.onixCodetable }));
                        return [3 /*break*/, 4];
                    case 2:
                        _a = _d.sent();
                        if (alive)
                            setInitialValues(null);
                        return [3 /*break*/, 4];
                    case 3:
                        if (alive)
                            setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            alive = false;
        };
    }, [id]);
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var codetableId;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    codetableId = (_a = data.codetableId) !== null && _a !== void 0 ? _a : initialValues === null || initialValues === void 0 ? void 0 : initialValues.codetableId;
                    return [4 /*yield*/, updateOnixCodetableItem(ky, id, {
                            onixCodetable: codetableId ? { id: codetableId } : undefined,
                            value: data.value,
                            description: data.description,
                            notes: data.notes,
                            sortOrder: data.sortOrder,
                            version: data.version,
                        })];
                case 1:
                    _b.sent();
                    // Forms cache ONIX codetables for an hour; drop the cache so the change shows up.
                    return [4 /*yield*/, queryClient.invalidateQueries(ONIX_CODETABLE_ITEMS_BY_NUMBER_KEY)];
                case 2:
                    // Forms cache ONIX codetables for an hour; drop the cache so the change shows up.
                    _b.sent();
                    if (returnPath) {
                        history.push(returnPath);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (loading || !initialValues)
        return null;
    return (React.createElement(OnixCodetableItemsForm, { initialValues: initialValues, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-agency.onix-codetable-items.edit.pane.title",
        }), isEdit: true, returnPath: returnPath }));
};
export default OnixCodetableItemsEdit;
